// HTTP client for the Al Professor Go backend (backend/).
// Sessions are an httpOnly cookie; the X-Requested-With header is required by
// the server on every write (CSRF protection).

export const API_BASE = process.env.REACT_APP_API_URL || "/api"

export class ApiError extends Error {
  constructor(message, status) {
    super(message)
    this.status = status
    this.code =
      status === 401 ? "unauthenticated" :
      status === 403 ? "permission-denied" :
      status === 404 ? "not-found" :
      status === 409 ? "already-exists" :
      status === 429 ? "resource-exhausted" : "unknown"
  }
}

export async function request(method, path, body, { headers, rawBody } = {}) {
  let res
  try {
    res = await fetch(API_BASE + path, {
      method,
      credentials: "include",
      headers: {
        "X-Requested-With": "alprofessor",
        ...(body !== undefined && !rawBody ? { "Content-Type": "application/json" } : {}),
        ...headers,
      },
      body: rawBody ?? (body !== undefined ? JSON.stringify(body) : undefined),
    })
  } catch (err) {
    throw new ApiError("Cannot reach the server. Check your connection and try again.", 0)
  }
  const text = await res.text()
  let data = null
  try {
    data = text ? JSON.parse(text) : null
  } catch {
    // non-JSON (e.g. proxy error page)
  }
  if (!res.ok) {
    throw new ApiError(data?.error || `Request failed (${res.status})`, res.status)
  }
  return data
}
